import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './redux/store';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import Landing from './Landing'
import PageNotFoundComponent from './components/PageNotFoundComponent';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
        <Routes>
          <Route path={`${process.env.REACT_APP_PREFIX}/`} element={<App />}/>          
          <Route path={`${process.env.REACT_APP_PREFIX}/landing`} element={<Landing />}/>          
          <Route path="*" element={<PageNotFoundComponent/>}/>
        </Routes>
      </BrowserRouter>      
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
